import GATSBY_COMPILED_MDX from "/home/runner/work/joint-lab.github.io/joint-lab.github.io/src/data/news/bcase_graduation.mdx";
import React from 'react';
import classnames from 'classnames';
import {graphql, Link} from "gatsby";
import {Page, Container, FlexLayout} from "components/core/layout";
import {MDXProvider} from "@mdx-js/react";
import {FiArrowRight} from 'react-icons/fi';
import {SubHero} from 'components/core/sub-hero';
import {Seo} from 'components/core/seo';
const shortcodes = {
  Link
};
function LinkToNews({header, title, slug, date, className}) {
  return React.createElement("div", {
    className: classnames("pt-4 w-full", className)
  }, React.createElement("div", {
    className: "text-gray-500 text-xs uppercase w-full"
  }, header), React.createElement(Link, {
    to: slug
  }, React.createElement("div", {
    className: "flex items-center space-x-1 text-green-700 hover:text-green-900 text-sm"
  }, React.createElement("span", {
    className: "inline-block truncate"
  }, title), React.createElement("span", {
    className: "inline-block"
  }, React.createElement(FiArrowRight)))), date ? React.createElement("p", {
    className: "text-sm text-gray-500"
  }, date) : null);
}
function ExtendedNewsPage({data: {mdx}, children, location, pageContext}) {
  return React.createElement(Page, {
    location: location,
    light: true
  }, React.createElement(SubHero), React.createElement(Container, {
    className: "mt-8 xl:mt-24 mb-8"
  }, React.createElement("div", {
    className: "text-center pb-8"
  }, React.createElement("p", {
    className: "text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold mb-4",
    style: {
      lineHeight: '1.3'
    }
  }, mdx.frontmatter.title), React.createElement("p", {
    className: "text-base font-medium text-gray-500"
  }, mdx.frontmatter.date)), React.createElement("hr")), React.createElement(Container, {
    className: "text-lg leading-relaxed mdx-content lg:mb-16"
  }, React.createElement(FlexLayout, null, React.createElement(FlexLayout.Item, {
    size: "sm",
    className: "sticky top-0 divide-y w-full px-4 space-y-4 hidden lg:block"
  }, pageContext.previous ? React.createElement(LinkToNews, Object.assign({}, pageContext.previous.node.frontmatter, {
    slug: pageContext.previous.node.fields.slug,
    header: 'Previous'
  })) : null, pageContext.next ? React.createElement(LinkToNews, Object.assign({}, pageContext.next.node.frontmatter, {
    slug: pageContext.next.node.fields.slug,
    header: 'Next'
  })) : null, React.createElement(LinkToNews, {
    title: 'Back to the news list',
    slug: `/news/${pageContext.page}`
  })), React.createElement(FlexLayout.Item, {
    size: "lg"
  }, React.createElement("div", {
    className: "space-y-8"
  }, React.createElement(MDXProvider, {
    components: shortcodes
  }, children))), React.createElement(FlexLayout.Item, {
    size: "sm",
    className: "divide-y w-full space-y-4 block lg:hidden my-4"
  }, pageContext.previous ? React.createElement(LinkToNews, Object.assign({}, pageContext.previous.node.frontmatter, {
    slug: pageContext.previous.node.fields.slug,
    header: 'Previous'
  })) : null, pageContext.next ? React.createElement(LinkToNews, Object.assign({}, pageContext.next.node.frontmatter, {
    slug: pageContext.next.node.fields.slug,
    header: 'Next'
  })) : null, React.createElement(LinkToNews, {
    title: 'Back to the news list',
    slug: `/news/${pageContext.page}`
  })))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(ExtendedNewsPage, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = ({data: {mdx}, location}) => React.createElement(Seo, {
  title: mdx.frontmatter.title,
  description: mdx.excerpt,
  pathname: location.pathname
});
export const query = graphql`
  query IdBasedNewsQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      frontmatter {
        title
        date(formatString: "MMMM Do, YYYY")
      }
      excerpt(pruneLength: 120)

    }
  }
`;
